import React, { ReactElement } from 'react';
import { Body, Headline, Text } from '../..';
import { LINK_BUTTON } from '../../link/variants';

export default function CommunityCallout(): ReactElement {
  return (
    <section className="mt-30 flex justify-center p-4">
      <div className="grid max-w-290 grid-cols-2 gap-12 max-[990px]:grid-cols-1 max-[990px]:[&>div:first-child]:order-1 max-[990px]:[&>div:first-child]:h-auto max-[990px]:[&>div:first-child>div]:w-full max-[990px]:[&>div:last-child]:flex max-[990px]:[&>div:last-child]:justify-center">
        <div className="flex items-center justify-start">
          <div className="w-108.25">
            <Text className="mb-4 block" level="mono" color="purple">
              It takes a village
            </Text>
            <Headline level="2" color="blue">
              Join the Stark community
            </Headline>
            <Body className="mt-4 mb-8" color="blue">
              Connect with a global community of experts from all industries and
              stay up to date with the largest collection of accessibility
              resources on the internet.
            </Body>

            <a href="/slack" className={LINK_BUTTON}>
              Join our community
            </a>
          </div>
        </div>
        <div className="relative">
          <img
            alt="Group of Stark users clustered in a circle with teal, yellow, and coral colored circles surrounding them."
            src="https://res.cloudinary.com/stark-lab/image/upload/v1761248842/marketing/highlights/homepage__community_wc4uun.webp"
            className="w-120.25 max-w-full"
          />
          <img
            src="/homepage__feature-5-arrow.svg"
            alt=""
            role="presentation"
            className="absolute -bottom-21 -left-22.5 h-42 w-33.75 max-[990px]:hidden"
          />
        </div>
      </div>
    </section>
  );
}
